import React from "react";
import { Row, Col } from "antd";

import AdSummary from "./AdSummary/AdSummary";
import { AdLink } from "./AdLink";
import { CoverImage } from "./CoverImage";
import styles from "./similarAdCard.scss";
import FavoriteButtonWhite from "../../containers/FavoriteButtonWhite";
import { CategoryName, CategoryNameHr, LinkTargetEnum } from "../../models";

function SimilarAdCard(props: any) {
  const {
    ad,
    adLists,
    hasFavorite,
    isMobile,
    onClick,
    className,
    classNameLink,
    category,
    flag,
    eventLabel
  } = props;

  const renderFavoriteButton = () => {
    if (!hasFavorite) {
      return null;
    }

    return (
      <span className={styles.bottomButtonContainer}>
        <FavoriteButtonWhite
          adLists={adLists}
          ad={ad}
          className={styles.bottomButton}
          category={category}
          flag={flag}
        />
      </span>
    );
  };

  const isPersonalCar = ad.category === CategoryName.car || ad.category === CategoryNameHr.car;
  const featuredLabel = isPersonalCar && ad.featuredProperty && ad.featuredProperty.label;

  // On mobile the pill moves out of the cover and above the price (rendered by
  // AdSummary). None of the callers pass isMobile, so the swap is done in scss.
  const renderBadges = () => {
    if (!featuredLabel && !ad.priceReductionPercentage) {
      return null;
    }
    return (
      <div className={styles.badges}>
        {featuredLabel && (
          <span className={styles.featuredProperty}>{featuredLabel}</span>
        )}
        {ad.priceReductionPercentage && (
          <span className={styles.percentage}>{ad.priceReductionPercentage}%</span>
        )}
      </div>
    );
  };

  return (
    <AdLink ad={ad} onClick={onClick} className={classNameLink} target={LinkTargetEnum.blank}>
      <Row className={`${styles.card} ${className}`} type="flex">
        <Col span={24} className={styles.coverCol}>
          <CoverImage ad={ad} isMobile={isMobile} eventLabel={eventLabel} />
          {renderBadges()}
          {renderFavoriteButton()}
        </Col>

        <Col span={24} className={styles.summaryContainer}>
          <AdSummary
            ad={ad}
            hasFavorite={hasFavorite}
            adLists={adLists}
            isMobile={isMobile}
            category={category}
            flag={flag}
            featuredLabel={featuredLabel}
            isPersonalCar={isPersonalCar}
          />
        </Col>
      </Row>
    </AdLink>
  );
}

SimilarAdCard.defaultProps = {
  onClick: () => null,
  hasFavorite: true,
  isMobile: false,
  className: "",
  classNameLink: "",
};

export default SimilarAdCard;



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/SimilarAdCard.tsx